import React from "react";
import ArcGauge from "./ArcGauge";
import Confetti from "./Confetti";
import CountUp from "./CountUp";
import { formatCurrency } from "../utils/format";
import { heatColor } from "../utils/heatColor";

// Het blok bovenaan: de meter met het teampercentage, de bedragen en de
// balk met hoeveel dagen en euro's er nog te gaan zijn.

// De bedragen tellen naar hun nieuwe waarde toe. Komt er een verkoop binnen,
// dan zie je het bedrag oplopen in plaats van in één frame te verspringen -
// dat is op afstand het duidelijkste teken dat er iets gebeurd is.
const Figure = ({ label, value }) => (
  <div className="hero-fig">
    <div className="k">{label}</div>
    <div className="v">
      €<CountUp value={value || 0} format={formatCurrency} />
    </div>
  </div>
);

const TeamTargetHero = ({ monthLabel, teamTarget, amount, progress }) => {
  const { hasTarget, percent, remaining, daysLeft, perDay } = progress;
  // Zonder bekend target nooit "gehaald": bij een mislukte teamTarget-call
  // zou het scherm anders vol confetti staan terwijl er niets gehaald is.
  const reached = hasTarget && percent >= 100;

  return (
    <section className="hero">
      {reached && <Confetti />}

      <div className={`hero-gauge${reached ? " is-complete" : ""}`}>
        <ArcGauge percent={percent} size={400} stroke={26} />
        <div className="gauge-readout">
          <b>
            <CountUp value={percent} />
            <em>%</em>
          </b>
          <span>
            {!hasTarget
              ? "TARGET ONBEKEND"
              : reached
                ? "TARGET GEHAALD"
                : "VAN TARGET"}
          </span>
        </div>
      </div>

      <div className="hero-main">
        <div className="hero-top">
          <h2 className="hero-title">Team target · {monthLabel}</h2>
          <div className="hero-badge">
            <span className="hero-badge-label">Uitje bij 100%</span>
            <span className="hero-badge-value">
              {teamTarget.text || "Nog niet bekend"}
            </span>
          </div>
        </div>

        <div className="hero-figs">
          <Figure label="Bedrag" value={amount} />
          <Figure label="Te gaan" value={hasTarget ? remaining : 0} />
          <Figure label="Target" value={hasTarget ? teamTarget.amount : 0} />
        </div>

        <div className="hero-bar">
          <div className="track">
            <i
              style={{
                width: `${percent}%`,
                background: `linear-gradient(90deg, ${heatColor(percent * 0.5)}, ${heatColor(percent)})`,
                boxShadow: `0 0 ${4 + 8 * (percent / 100)}px ${heatColor(percent, 0.5)}`,
              }}
            />
          </div>
          <div className="hero-meta">
            <span>{daysLeft} dagen te gaan</span>
            <span>
              €<CountUp value={perDay || 0} format={formatCurrency} /> per dag nodig
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamTargetHero;
